import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-update-allergy',
  templateUrl: './update-allergy.component.html',
  styleUrls: ['./update-allergy.component.css']
})
export class UpdateAllergyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
